/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-07-13 18:13:20
 * @LastEditors: xiawenlong
 * @LastEditTime: 2025-12-02 15:34:18
 */
import config from './config/dashboard'
import axios from '@/utils/request'
export const platformTotal = params => axios.post(config.platformTotal, params)
export const productSale = params => axios.post(config.productSale, params)
export const annualSaleAmount = params => axios.post(config.annualSaleAmount, params)
export const annualSaleQuantity = params => axios.post(config.annualSaleQuantity, params)
export const areaSaleTotal = params => axios.post(config.areaSaleTotal, params)
export const productLaunch = params => axios.post(config.productLaunch, params)
export const buyerMonth = params => axios.post(config.buyerMonth, params)
export const supplierSale = params => axios.post(config.supplierSale, params)
export const productionSaleTotal = params => axios.post(config.productionSaleTotal, params)
export const freightReport = params => axios.post(config.freightReport, params)
export const amountTotal = params => axios.post(config.amountTotal, params)
export const plaformInfo = params => axios.post(config.plaformInfo, params)
export const bszProductList = params => axios.post(config.bszProductList, params)
export const onsaleMaterailPage = params => axios.post(config.onsaleMaterailPage, params)
export const groupMaterialPage = params => axios.post(config.groupMaterialPage, params)
export const userCusPage = params => axios.post(config.userCusPage, params)
export const bizCusPage = params => axios.post(config.bizCusPage, params)
export const bizSupplierPage = params => axios.post(config.bizSupplierPage, params)
export const userOrderPage = params => axios.post(config.userOrderPage, params)
export const groupOrderPage = params => axios.post(config.groupOrderPage, params)
export const bizOrderPage = params => axios.post(config.bizOrderPage, params)
export const getAreaSaleTotalDetail = params => axios.post(config.getAreaSaleTotalDetail, params)
export const areaCompanyList = params => axios.post(config.areaCompanyList, params)
export const areaCompanyProduct = params => axios.post(config.areaCompanyProduct, params)
export const areaCompanyOrder = params => axios.post(config.areaCompanyOrder, params)
export const customerPurchaseRank = params => axios.post(config.customerPurchaseRank, params)
export const materialSalePricePage = params => axios.post(config.materialSalePricePage, params)
export const thirdOrderPage = params => axios.post(config.thirdOrderPage, params)
export const dashboardLogin = params => axios.post(config.dashboardLogin, params)
export const dashboardCheckToken = params => axios.post(config.dashboardCheckToken, params)
